export enum LocalStorageKey {
  AuthInfo = "AUTH_INFO",
  PendingRedirectPath = "PENDING_REDIRECT_PATH",
  PendingEphemeralRouteAction = "PENDING_EPHEMERAL_ROUTE_ACTION",
  UpgradedUserEmail = "UPGRADED_USER_EMAIL",
  StripeLastCheckoutSession = "STRIPE_LAST_CHECKOUT_SESSION",
  ThemeType = "THEME_TYPE",
  LastUsedAuthMethod = "LAST_USED_AUTH_METHOD",
}
